<template>
  <div id="container">
    <div class="box-content-title">
      <div class="title-font-style">
        <span>团队报价记录</span>
      </div>
    </div>
    <el-form class="search-style">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item>
            <el-select v-model="queryParams.column" @change="onChangeColumn">
              <el-option
                v-for="(item, index) in teamQuotationRecord"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :span="4"
          v-show="queryParams.column === 'orderCost'||queryParams.column === 'orderTotal'||queryParams.column === 'orderRate'"
        >
          <el-form-item>
            <el-select v-model="queryParams.expression">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in expressionList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <!-- <el-select
                v-model="queryParams.value"
                v-if="queryParams.column==='state' || queryParams.column==='invoiceType'"
              >
                <el-option
                  v-for="(item, i) in stateList"
                  :key="i"
                  :label="item.lab"
                  :value="item.val"
                ></el-option>
            </el-select>-->
            <el-select v-model="queryParams.value" v-if="queryParams.column==='isContract'">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
            <el-date-picker
              style="width:100%"
              v-else-if="queryParams.column==='miDate' ||queryParams.column==='maxDate' ||queryParams.column==='generateDate' || queryParams.column==='createDate'"
              v-model="time"
              value-format="yyyy-MM-dd HH:mm"
              type="daterange"
              :default-time="['00:00:00','23:59:59']"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <el-input v-else v-model="queryParams.value" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item></el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="box-table" :style="{height: $store.state.Sell.heightTitle+'px'}">
      <el-table
        border
        ref="tableRef"
        :data="list"
        :max-height="$store.state.Sell.heightTitle"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="orderCode" label="报价单编号" width="150" fixed>
          <template slot-scope="scope">
            <span
              class="approval"
              @click="goSellProductsEnquiry(scope.row)"
            >{{ scope.row.orderCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cusName" width="180" label="客户名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="toCusName(scope.row)"
            >{{ scope.row.cusName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="产品清单">
          <template slot-scope="scope">
            <el-popover
              :open-delay="200"
              @show="onQueryByOcbId(scope.row)"
              placement="right"
              width="680"
              trigger="hover"
            >
              <el-table :data="gridData" border max-height="480">
                <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
                <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="proType" label="型号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ocNeednumber" label="数量" width="85"></el-table-column>
                <el-table-column prop="ocUnit" label="单位" width="50"></el-table-column>
                <el-table-column label="货期" width="65">
                  <template slot-scope="scope">{{scope.row.ocExtime}}天</template>
                </el-table-column>
              </el-table>
              <el-button type="text" slot="reference">查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="orderTotal" label="报价总额" min-width="90">
          <template slot-scope="scope">{{scope.row.orderTotal|priceFilter}}</template>
        </el-table-column>
        <el-table-column prop="orderCost" label="供货成本" min-width="90">
          <template slot-scope="scope">{{scope.row.orderCost|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="毛利率">
          <template slot-scope="scope">{{scope.row.orderRate|perCentFilter}}</template>
        </el-table-column>
        <el-table-column prop="miDate" width="130" label="询价时间">
          <template slot-scope="scope" v-if="scope.row.miDate">{{scope.row.miDate|dateFilter}}</template>
        </el-table-column>
          <el-table-column label="反馈人">
            <template slot-scope="scope">{{scope.row.oiName||'--'}}</template>
          </el-table-column>
        <el-table-column label="供货价反馈时间" width="130">
          <template slot-scope="scope">{{scope.row.maxDate|dateFilterL}}</template>
        </el-table-column>
        <el-table-column label="供货价有效期" width="130">
          <template slot-scope="scope">{{scope.row.unitDate|dateFilterL}}</template>
        </el-table-column>
        <el-table-column prop label="报价单生成时间" width="130">
          <template slot-scope="scope">{{scope.row.generateDate|dateFilterL}}</template>
        </el-table-column>
        <el-table-column label="生成合同">
          <template slot-scope="scope">{{scope.row.isContract===1?'是':'否'}}</template>
        </el-table-column>
        <el-table-column prop="createUser" label="制单人"></el-table-column>
        <el-table-column prop="orgName" label="所属部门"></el-table-column>
        <el-table-column width="130" label="制单时间">
          <template slot-scope="scope">{{scope.row.createDate|dateFilterL}}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { teamQuotationRecord } from './util/data'
import { orderBasete, orderContentQueryByOcbId } from '@/api/sell/sellManage'
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
export default {
  components: { pagination },
  data() {
    return {
      stateList: [
        { lab: '审核中', val: 1 },
        { lab: '待处理', val: 2 },
        { lab: '审核不通过', val: 3 },
        { lab: '退回修改', val: 4 },
        { lab: '提现成功', val: 5 },
        { lab: '付款失败', val: 6 }
      ], // 提现状态
      expressionList,
      columnArr: [],
      gridData: [],
      queryParams: {
        column: 'cusName',
        value: ''
      },
      teamQuotationRecord, // 搜索下拉数据
      list: [], // 列表数据
      loadingTable: false, // 列表loading
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      time: [],
      timeValue: [],
      total: 0 // 列表总数
    }
  },
  watch: {
    queryParams (val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'cusName')
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    goSellProductsEnquiry(val) {
      this.$router.push({ name: 'sellInquiryDetails', query: { id: val.id } })
    },
    toCusName(row) {
      this.$router.push({ name: 'customer/details', query: { id: row.cusId } })
    },
    // 查看产品清单
    onQueryByOcbId(row) {
      this.gridData = []
      orderContentQueryByOcbId(row.id).then((res) => {
        if (res.data.code === 200) {
          this.gridData = res.data.obj
        }
      })
    },
    onSearch() {
      // 搜索
      if (this.time.length === 2) {
        this.queryParams.value = this.time[0]
        this.queryParams.endValue = this.time[1]
      }
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.columnArr = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    onReset() {
      this.columnArr = []
      this.queryParams = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    getList() {
      this.loadingTable = true
      const obj = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      orderBasete(this.currentPage, this.pageSize, obj).then((res) => {
        if (res.data.code === 200) {
          this.loadingTable = false
          this.list = res.data.obj.records
          this.total = res.data.obj.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onChangeColumn(val) {
      // 改变下拉框
      this.time = []
      this.queryParams = {}
      this.queryParams.column = val
      if (
        this.queryParams.column === 'orderCost' ||
        this.queryParams.column === 'orderTotal' ||
        this.queryParams.column === 'orderRate'
      ) {
        this.$set(this.queryParams, 'expression', 'eq')
      }
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
